$(function() {
  accessoriesHashChange();
  $(window).on('load', accessoriesHashChange);
  $(window).on('hashchange', function() {
    accessoriesHashChange();
    accessoriesTabAction();
  });

  $(`#site-header .nav-bar a[href*="/pages/accessories"], #NavDrawer a[href*="/pages/accessories"]`).on('click', accessoriesHashChange);
});
function accessoriesHashChange() {
  var el = $(`.cms_navigation_menu > .tabs > .cms_navigation_menu_tab[data-hash="${window.location.hash.replace('#','')}"]`);
  if (el.length == 0) return;

  // hide menu
  if ($('body').hasClass('menu-open')) {
    $('body').removeClass('menu-open')
    $('.site-nav__item-toggle').removeClass('meganav--active');
    var dropdown = $('.site-nav__item-toggle').parents('.meganav');
    dropdown.hide();
    setTimeout(function() {
      dropdown.removeAttr('style');
    }, 500);
  }
  if ($('body').hasClass('js-drawer-open')) {
    $('#SiteNavCompressed').trigger('click');
  }

  $('html,body').animate({
    scrollTop: el.offset().top,
  }, 300);
}
function accessoriesTabAction() {
  var el = $(`.cms_navigation_menu > .tabs > .cms_navigation_menu_tab[data-hash="${window.location.hash.replace('#','')}"]`);
  if (el.length == 0) return;

  // toggle tab
  el.trigger('click');
}